/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_Dont_Show_AgainInputs */



/**
* | output |
* | --- |
* | "Don't show again" |
*
* @param {Desktop_Banner_Dont_Show_AgainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_dont_show_again = /** @type {((inputs?: Desktop_Banner_Dont_Show_AgainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_Dont_Show_AgainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne plus afficher")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht wieder anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non mostrare più")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Больше не появляйтесь.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No volver a mostrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不要再次显示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再度表示しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दोबारा मत दिखाओ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não mostrar novamente")
	return /** @type {LocalizedString} */ ("Don't show again")
});